import { render, staticRenderFns } from "./BoardListHomeDonateLayout.vue?vue&type=template&id=fbdf803c&scoped=true&"
import script from "./BoardListHomeDonateLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListHomeDonateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdf803c",
  null
  
)

export default component.exports